import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FormTemplate } from 'api/form';
import { Button } from 'components/atoms/button';
import { Modal } from 'components/atoms/modal';
import { useTranslate } from 'hooks/use-translation';

interface Props {
  closeModal: () => void;
  isVisible: boolean;
  toggleFormAutomation: (
    enableAutomation: boolean,
    updateAllInstances: boolean,
  ) => void;
  formTemplate: FormTemplate;
}

const StyledButton = styled(Button)`
  margin-left: var(--spacing-03);
`;

export const FormAutomationModal: FC<Props> = ({
  closeModal,
  isVisible,
  toggleFormAutomation,
  formTemplate,
}) => {
  const enabled = formTemplate.automation?.enabled;
  const translate = useTranslate();
  const enableTitle = translate(
    'form_template.automation.enable_disable_automation_heading',
    {
      action: enabled ? translate('disable') : translate('enable'),
    },
  );
  const yesButtonText = translate('yes');
  const noButtonText = translate('no');

  const updatedState = formTemplate.automation ? !enabled : true;

  return (
    <Modal
      visible={isVisible}
      title={enableTitle}
      okText={yesButtonText}
      okButtonProps={{ type: 'primary', danger: false }}
      cancelText={noButtonText}
      footer={[
        <Button onClick={() => toggleFormAutomation(updatedState, false)}>
          {noButtonText}
        </Button>,
        <StyledButton
          type="primary"
          onClick={() => toggleFormAutomation(updatedState, true)}
        >
          {yesButtonText}
        </StyledButton>,
      ]}
      onCancel={closeModal}
    >
      <FormattedMessage
        id="form_template.automation.enable_disable_automation_description"
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
          action: enabled ? translate('disable') : translate('enable'),
          form_automation_status: enabled ? 'off' : 'on',
        }}
      />
    </Modal>
  );
};
